// extracted by mini-css-extract-plugin
module.exports = {"SectionA1":"SectionA1_SectionA1__i1JDO"};